import { useTranslation } from 'next-i18next';
import { useContext, useEffect, useState, VFC } from 'react';

import styles from '@/containers/MarketplacePage/FilterSideBar/FilterSideBar.module.scss';
import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import ChevronRight2 from '@/icons/chevron-right2.svg';

import { MarketplaceUserStatus, UserType } from '../interface';

type CheckBoxState = Map<string, boolean>;

type Props = {
  checkboxState: CheckBoxState;
  setCheckboxState: (checkboxState: CheckBoxState) => void;
};

const Verification: VFC<Props> = ({
  checkboxState,
  setCheckboxState,
}: Props) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const { searchConditionUsers, setSearchConditionUsers } = useContext(
    MarketplaceItemsContext
  );

  const handleStatusChange = (newStatus: UserType): void => {
    const newSearchConditionUsers = {
      ...searchConditionUsers,
      verification: newStatus,
    };
    setSearchConditionUsers(newSearchConditionUsers);
  };

  const statuses: {
    [key in MarketplaceUserStatus]: string;
  } = {
    artist: t('filterSidebar.verification.options.artist'),
    collector: t('filterSidebar.verification.options.collector'),
  };
  const handleOnClick = (e: React.MouseEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    //only this one is checked
    if (!canUncheck && !target.checked === true) {
      e.preventDefault();
    } else {
      const newCheckboxState = new Map<string, boolean>();
      let verification: UserType;
      if (target.id.indexOf('artist') > 0) {
        newCheckboxState.set('artist', !checkboxState.get('artist'));
        newCheckboxState.set('collector', checkboxState.get('collector'));
      } else {
        newCheckboxState.set('artist', checkboxState.get('artist'));
        newCheckboxState.set('collector', !checkboxState.get('collector'));
      }
      verification =
        newCheckboxState.get('artist') === true &&
        newCheckboxState.get('collector') === true
          ? 'all'
          : verification;
      verification =
        newCheckboxState.get('artist') == true &&
        newCheckboxState.get('collector') === false
          ? 'artist'
          : verification;
      verification =
        newCheckboxState.get('artist') === false &&
        newCheckboxState.get('collector') === true
          ? 'collector'
          : verification;
      handleStatusChange(verification);
      setCheckboxState(newCheckboxState);
    }
  };
  const canUncheck =
    checkboxState.get('artist') === true &&
    checkboxState.get('collector') === true;
  return (
    <div className={styles.sidebarSubsection}>
      <div className={styles.title}>
        {t('filterSidebar.verification.heading')}
      </div>
      <ChevronRight2
        className={
          isCollapsed ? styles.collapseButtonClicked : styles.collapseButton
        }
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      />
      {!isCollapsed && (
        <div className={styles.availabilityRadios}>
          {Object.entries(statuses).map(([key, value]) => (
            <div key={key} className={'form-check checkbox'}>
              <input
                className="form-check-input"
                id={`radio${key}`}
                type="checkbox"
                value={key}
                checked={checkboxState.get(key)}
                onClick={(e) => {
                  handleOnClick(e);
                }}
              />
              <label htmlFor={`radio${key}`} className={'checkbox-label'}>
                {value}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Verification;
